import '../applied_filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedModeratorView extends Monitoring.Views.SocialContents.Filters.AppliedFilterView
  template: JST["backbone/templates/monitoring/filters/moderator/applied_moderator"]
  name: 'moderators'

  unmodifiableByModerators: true

  events: =>
    return _.extend({}, Monitoring.Views.SocialContents.Filters.AppliedFilterView.prototype.events, {
      "click .remove_manual_moderation" : "removeManualModeration"
    })

  removeFilter: (value) ->
    @searchQuery.removeModerator(value)

  removeManualModeration: (value) ->
    @searchQuery.setManualModeration(false)
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)